export const P00062ModeFonctionnementRegulation = [
  { ref: 0, label: 'P00062.params.modeFonctionnementRegulation.smart' },
  { ref: 1, label: 'P00062.params.modeFonctionnementRegulation.boost' },
  { ref: 2, label: 'P00062.params.modeFonctionnementRegulation.eco' },
];
